
export const calculateBeyondTestResults = (answers) => {
    // S: Q1-Q5
    // E: Q6-Q10
    // B: Q11-Q15

    const counts = {
        S: { A: 0, B: 0, C: 0, D: 0 },
        E: { A: 0, B: 0, C: 0, D: 0 },
        B: { A: 0, B: 0, C: 0, D: 0 }
    };

    Object.entries(answers).forEach(([qIdx, answer]) => {
        const q = parseInt(qIdx);
        if (q >= 1 && q <= 5) {
            counts.S[answer]++;
        } else if (q >= 6 && q <= 10) {
            counts.E[answer]++;
        } else if (q >= 11 && q <= 15) {
            counts.B[answer]++;
        }
    });

    const getDominantType = (axisCounts) => {
        // Find the key with the maximum value
        return Object.keys(axisCounts).reduce((a, b) => axisCounts[a] >= axisCounts[b] ? a : b);
    };

    const calculateScore = (axisCounts) => {
        // A=1, B=2, C=3, D=4 points
        // Total range for 5 questions: Min 5 (all A), Max 20 (all D)
        const points = (axisCounts.A * 1) + (axisCounts.B * 2) + (axisCounts.C * 3) + (axisCounts.D * 4);
        const minPoints = 5;
        const maxPoints = 20;
        // Normalize to 0-100
        return Math.round(((points - minPoints) / (maxPoints - minPoints)) * 100);
    };

    const result = {
        S: getDominantType(counts.S),
        E: getDominantType(counts.E),
        B: getDominantType(counts.B),
        scores: {
            S: calculateScore(counts.S),
            E: calculateScore(counts.E),
            B: calculateScore(counts.B)
        },
        rawCounts: counts
    };

    return result;
};
